export class WebUI {
    constructor()
    {
        this.subscribers = [];
        this.dom_body = document.body;
        this.scroll_subscribers = [];
        this.window_width = 0;
        this.window_height = 0;

        // window.addEventListener('scroll', this.debounce(this.scrollDepth.bind(this), 8));

        this.getWindowSize();
        window.addEventListener("scroll", this.throttle(this.scrollDepth.bind(this), 25));
    }

    documentBodyFreeze(status)
    {

        if (!status) {
            this.dom_body.classList.remove('block-scroll');
            return;
        }

        if (this.dom_body.classList.contains('block-scroll')) {
            this.dom_body.classList.remove('block-scroll');
        } else {
            this.dom_body.classList.add('block-scroll');
        }
    }

    getWindowSize() {
      let w = window;
      let d = document;
      let e = d.documentElement;
      let g = d.getElementsByTagName('body')[0];

      this.window_width = w.innerWidth || e.clientWidth || g.clientWidth;
      this.window_height = w.innerHeight || e.clientHeight || g.clientHeight;
    }

    scrollDepth()
    {
        this.scroll_subscribers.forEach(s => {
            s(window.pageYOffset, this.window_width, this.window_height);
        })
    }

    debounce(fn, wait)
    {
        var timeout
        return function () {
            clearTimeout(timeout)
            var args = arguments
            timeout = setTimeout(function () {
                fn.apply(this, args)
            }, (wait || 1))
        }
    }

    throttle(callback, limit)
    {
        var wait = false;                  // Initially, we're not waiting
        return function () {
               // We return a throttled function
            if (!wait) {                   // If we're not waiting
                callback.call();           // Execute users function
                wait = true;               // Prevent future invocations
                setTimeout(function () {
           // After a period of time
                    wait = false;          // And allow future invocations
                }, limit);
            }
        }
    }

    scrollSubscribe(subscriber)
    {
        this.scroll_subscribers.push(subscriber)
    }
}
